import * as identityStore from '@core/identity/store';

export const coreEffects = [identityStore.IdentityEffects];
